// auth-guard.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../shared/services/auth/auth.service';
import { filter, map, Observable, take } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
    private authService: AuthService, 
    private router: Router
  ) { }

  canActivate(): Observable<boolean> {
    const signalAuth = this.authService.$isAuthenticated;

    return toObservable(signalAuth).pipe(
      filter((val) => val !== null),
      take(1),
      map((isAuth) => {
        if (isAuth) {
          return true;
        } else {
          this.router.navigate(['/login'], { replaceUrl: true });
          return false;
        }
      })
    );
  }
}
